import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { companyProductsSchema } from '../schemas/company-products.schema';
import { companySchema } from '../schemas/company.schema';
import { mobileProductSchema } from '../schemas/mobile-product.schema';
import { webProductSchema } from '../schemas/web-product.schema';

const productsSchema = companyProductsSchema.extend({
  mobileProducts: z.array(
    mobileProductSchema.pick({
      productId: true,
    })
  ),
  webProducts: z.array(
    webProductSchema.pick({
      productId: true,
    })
  ),
});

const requestSchema = companySchema
  .pick({
    alias: true,
    externalAccountId: true,
    products: true,
  })
  .required({ products: true })
  .extend({
    products: productsSchema,
  });

/**
 * Used by a Trimble Maps Partner to remove mobile or web products from a company
 * @param alias Alias of the company
 * @param externalAccountId External Account ID of the Company
 * @param products.mobileProducts Array of Mobile Product IDs to remove
 * @param products.webProducts Array of Web Product IDs to remove
 * @returns Data object indicating success
 */
export function deleteCompanyProducts(
  this: unknown,
  request: z.infer<typeof requestSchema>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).companyUrl}/products`, {
        method: 'DELETE',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(request),
      })
    )
  ).pipe(
    selectData(
      z.object({
        href: z.string().nullable(),
        data: z.boolean(),
      })
    )
  );
}
